import ItemDetailContainer from "./ItemDetailContainer";

export default ItemDetailContainer;
